import { render, staticRenderFns } from "./DialogShowProgramsPromoter.vue?vue&type=template&id=01f55323&"
import script from "./DialogShowProgramsPromoter.vue?vue&type=script&lang=js&"
export * from "./DialogShowProgramsPromoter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports